import { FormValidation } from '@zazume/zzm-base';

import { TFunction } from '#/hooks/useI18n';
import { toFormValidation } from '#/utils/formValidation/toFormValidation';

import { DocumentCategories } from '../../models';
import { getCreateDocumentSchema } from './CreateDocument.schema';

export const schema = t => {
  return getCreateDocumentSchema(t).omit(['signers', 'signatureConfiguration']);
};

export type UpdateDocumentFormInputs = {
  category: DocumentCategories;
  type: string;
  isExpirable: boolean;
  isSignable: boolean;
  expireAt: Date | undefined;
  document: any;
  isHiddenFromOwner: boolean;
};

export const getUpdateDocumentSchema = (t: TFunction): FormValidation => toFormValidation(t, schema(t));
